// eslint-disable-next-line max-classes-per-file
import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { ITripNote } from '~/api/ITripNote';

export class TripNote implements ITripNote {
  @Ref tripId: string;
  @Ref noteTypeId: number;
  @Ref noteId?: number;
  @Ref note: string;
  @Ref status?: number;
  @Ref who?: string;
  @Ref timestamp?: string;

  constructor(data: Partial<ITripNote>) {
    assignOwnProperties(this, normalize(data));
  }
}
